<script setup lang="ts">
import type { IDrawerTextAndImageBlockProps } from '../types'

const props = defineProps<IDrawerTextAndImageBlockProps>()
</script>

<template>
    <section>
        <div class="flex items-center gap-4 lg:gap-8">
            <div class="grow">
                <div
                    v-if="props.badges?.length"
                    class="gap-xs flex"
                >
                    <VBadge
                        v-for="(badge, index) in props.badges?.slice(0, 2)"
                        :key="`badge_${index}`"
                        :data-test="`badge_${index}`"
                        :variant="badge.visualVariant"
                        size="SMALL"
                        :icon="badge.icon"
                    >
                        {{ badge.label }}
                    </VBadge>
                </div>

                <div
                    v-if="props.heading"
                    class="heading-sm lg:heading-md text-neutral-primary font-boldest my-2 line-clamp-4 break-all leading-normal"
                >
                    {{ heading }}
                </div>

                <div
                    v-if="props.paragraph"
                    v-html-gpp="props.paragraph"
                    class="paragraph-md text-neutral-primary overflow-hidden text-ellipsis font-medium max-lg:hidden"
                />
            </div>

            <div
                v-if="props.image"
                class="max-h-[96px] min-h-[96px] min-w-[96px] max-w-[96px] lg:max-h-[144px] lg:min-h-[144px] lg:min-w-[144px] lg:max-w-[144px]"
            >
                <BaseImage
                    :image-data="image"
                    class="size-[96px] lg:size-[144px]"
                />
            </div>
        </div>

        <div
            v-if="props.paragraph"
            v-html-gpp="props.paragraph"
            class="paragraph-lg text-neutral-primary font-medium lg:hidden"
        />
    </section>
</template>
